import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";

const TooltipList = ({
    items,
    col = "col",
    i18nActive = false,
    handleClick,
    isSelected,
    t
}: any) => {
    const refs = useRef<(HTMLDivElement | null)[]>([]);
    const [overflowFlags, setOverflowFlags] = useState<boolean[]>([]);

    useEffect(() => {
        if (!items) return;
        
        const observer = new ResizeObserver(() => {
            const result = refs.current.map(el =>
                el ? el.scrollWidth > el.clientWidth : false
            );
            setOverflowFlags(result);
        });

        refs.current.forEach(el => el && observer.observe(el));

        return () => observer.disconnect();
    }, [items]);

    return (
        <>
            {items.map((item: any, index: number) => {
                const text = i18nActive ? t(item.name) : item.name;
                const isOverflow = overflowFlags[index];
                const selected = isSelected(item);

                return (
                    <div className={col} key={index}>
                        <Button
                            className="p-button-outlined p-button-secondary w-full opacity-60"
                            style={{
                                borderRadius: "8px",
                                height: "1.875rem",
                                padding: 5,
                                border: "0.75px solid #E0E3EE",
                                backgroundColor: selected ? "#6383F4" : "transparent"
                            }}
                            onClick={() => handleClick(item)}
                        >
                                <div
                                    ref={(el) => (refs.current[index] = el)}
                                    className={`item-tooltip text-center w-full`}
                                    data-pr-tooltip={isOverflow ? text : undefined}
                                    style={{
                                        justifyContent: isOverflow ? "flex-start" : "center",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        color: selected ? "#fff" : "#2D3967"
                                    }}
                                >
                                {text}
                            </div>
                        </Button>
                    </div>
                );
            })}
        </>
    );
};

export default TooltipList;